import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginPage from '../views/LoginPage.vue'

Vue.use(VueRouter)

// 家脉管理系统路由
// name 会作为顶部 Tab 的标题（App.vue 从 $router.options.routes 自动生成 routeMap），务必填写
const routes = [
  { path: '/', redirect: '/home' },
  { path: '/login', name: '登录', component: LoginPage },
  { path: '/home', name: '主页', component: () => import('@/views/HomePage.vue') },

  // ===== 系统管理 =====
  {
    path: '/system/company',
    name: '公司管理',
    component: () => import('@/views/system/company/index.vue')
  },
  {
    path: '/system/dept',
    name: '部门管理',
    component: () => import('@/views/system/dept/index.vue')
  },
  {
    path: '/system/person',
    name: '人员管理',
    component: () => import('@/views/system/person/index.vue')
  },
  {
    path: '/system/admin',
    name: '账号管理',
    component: () => import('@/views/system/admin/index.vue')
  },
  {
    path: '/system/role',
    name: '角色管理',
    component: () => import('@/views/system/role/index.vue')
  },
  {
    path: '/system/menu',
    name: '菜单管理',
    component: () => import('@/views/system/menu/index.vue')
  },
  {
    path: '/system/config',
    name: '系统参数',
    component: () => import('@/views/system/config/index.vue')
  },

  // ===== 字典管理（每个分类组一个二级菜单，共用同一页面组件） =====
  { path: '/dict', redirect: '/dict/activity_category' },
  { path: '/dict/activity_category', name: '活动类别', component: () => import('@/views/system/dict/index.vue') },
  { path: '/dict/content_category', name: '内容分类', component: () => import('@/views/system/dict/index.vue') },
  { path: '/dict/banner_position', name: '轮播图位置', component: () => import('@/views/system/dict/index.vue') },
  { path: '/dict/tower_section', name: '塔林介绍板块', component: () => import('@/views/system/dict/index.vue') },
  { path: '/dict/benefit_category', name: '券类型', component: () => import('@/views/system/dict/index.vue') },
  { path: '/dict/dispatch_milestone', name: '发放条件', component: () => import('@/views/system/dict/index.vue') },
  { path: '/dict/scenic_level', name: '景区等级', component: () => import('@/views/system/dict/index.vue') },
  { path: '/dict/facility_category', name: '配套设施类别', component: () => import('@/views/system/dict/index.vue') },
  { path: '/dict/benefit_instruction', name: '权益券文案', component: () => import('@/views/system/dict/index.vue') },

  // ===== 日志中心 =====
  {
    path: '/log/operation',
    name: '操作日志',
    component: () => import('@/views/log/operation.vue')
  },
  {
    path: '/log/login',
    name: '登录日志',
    component: () => import('@/views/log/login.vue')
  },
  {
    path: '/log/sql',
    name: '数据库日志',
    component: () => import('@/views/log/sql.vue')
  },
  {
    path: '/log/share',
    name: '扫码日志',
    component: () => import('@/views/log/share.vue')
  },

  // ===== 活动管理 =====
  { path: '/activity', redirect: '/activity/list' },
  {
    path: '/activity/list',
    name: '活动列表',
    component: () => import('@/views/activity/index.vue')
  },

  // ===== 内容管理 =====
  { path: '/content', redirect: '/content/banner' },
  {
    path: '/content/banner',
    name: '轮播图',
    component: () => import('@/views/content/banner/index.vue')
  },
  {
    path: '/content/official',
    name: '官方内容',
    component: () => import('@/views/content/official/index.vue')
  },
  {
    path: '/content/post',
    name: '社区帖子',
    component: () => import('@/views/content/post/index.vue')
  },
  {
    path: '/content/launch',
    name: '落地页',
    component: () => import('@/views/content/launch/index.vue')
  },
  {
    path: '/content/tower',
    name: '塔林介绍',
    component: () => import('@/views/content/tower/index.vue')
  },
  {
    path: '/content/notice',
    name: '公告',
    component: () => import('@/views/content/notice/index.vue')
  },
  {
    path: '/stay/base',
    name: '旅居基地',
    component: () => import('@/views/stay/base/index.vue')
  },
  {
    path: '/stay/scenic',
    name: '周边景区',
    component: () => import('@/views/stay/scenic/index.vue')
  },
  {
    path: '/stay/community',
    name: '小区管理',
    component: () => import('@/views/stay/community/index.vue')
  },

  {
    path: '/user/list',
    name: '用户列表',
    component: () => import('@/views/user/list/index.vue')
  },
  {
    path: '/user/auth',
    name: '实名认证',
    component: () => import('@/views/user/auth/index.vue')
  },

  {
    path: '/benefit/checkin',
    name: '券码核销',
    component: () => import('@/views/benefit/checkin/index.vue')
  },
  {
    path: '/benefit/list',
    name: '权益券',
    component: () => import('@/views/benefit/list/index.vue')
  },
  {
    path: '/benefit/user',
    name: '持券记录',
    component: () => import('@/views/benefit/user/index.vue')
  },
  {
    path: '/benefit/verify',
    name: '核销记录',
    component: () => import('@/views/benefit/verify/index.vue')
  },
  {
    path: '/order/appointment',
    name: '预约列表',
    component: () => import('@/views/order/appointment/index.vue')
  },
  {
    path: '/order/purchase',
    name: '购买记录',
    component: () => import('@/views/order/purchase/index.vue')
  },

  // ===== 个人相关（顶栏入口：铃铛/信封/头像下拉，不进侧边栏菜单，不加 tb_sys_menu 节点） =====
  {
    path: '/mine',
    name: '个人中心',
    component: () => import('@/views/mine/profile.vue')
  },
  {
    path: '/mine/password',
    name: '修改密码',
    component: () => import('@/views/mine/password.vue')
  },
  {
    path: '/mine/notice',
    name: '我的通知',
    component: () => import('@/views/mine/messages/index.vue'),
    props: { mode: 'notice' }
  },
  {
    path: '/mine/message',
    name: '我的消息',
    component: () => import('@/views/mine/messages/index.vue'),
    props: { mode: 'business' }
  },

  // 未匹配的地址回主页，避免白屏
  { path: '*', redirect: '/home' }
]

const router = new VueRouter({
  routes
})

// chunk 加载失败兜底：发版/重启 dev server 后，旧页面按需拉新 chunk 会 404/拒连，
// 此时整页刷新一次即可拿到最新构建（防死循环：sessionStorage 记录本次会话已刷过）
router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message && (pattern.test(error.message) || /Loading CSS chunk .* failed/.test(error.message))
  if (isChunkLoadFailed && !sessionStorage.getItem('chunk_reloaded')) {
    sessionStorage.setItem('chunk_reloaded', '1')
    location.reload()
  }
})

export default router
